

import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { Line } from "react-chartjs-2";
import { chartOptions, buildChartV2, buildSignUpPercentChart } from "../../helpers/utils";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import TMHLoader from "../TMHLoader/TMHLoader"

export default function SignUpChart( {signupMethod, numberLastDays} ) {
    const [datasets, setDatasets] = useState()
    const [labels, setLabels] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { token } = useToken()
    const { timeZone } = useTimeZone()

    useEffect(() => {
        async function initData() {
            console.log('SignUpChart: update data')
            if (parseInt(numberLastDays) === 0) return
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
            }

            var params = new URLSearchParams({
                'timezone_offset_minutes': timeZone * -60,
                'number_last_days': numberLastDays
            })

            fetch(process.env.REACT_APP_BASE_URL + "dashboard/signup_chart?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    async (result) => {
                        var json = result.json
                        if (result.ok) {
                            var datasets = json?.data.datasets
                            var labels = json?.data.labels
                            setDatasets(datasets)
                            setLabels(labels)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [setIsLoading, token, numberLastDays, timeZone])

    return (
        <TMHLoader active={isLoading}>

            <Row>
                <Col md="12">
                    <Card className="card-chart">
                        <CardHeader>
                            <Row>
                                <Col className="text-left" sm="6">
                                    <h5>Users Synced By Day { (signupMethod !== "All") && (" - " + signupMethod) }</h5>

                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="chart-area">
                            <div className="chart-area">
                                    {
                                        datasets && signupMethod === "All" &&<Line
                                            data={buildChartV2(labels, datasets["All"])}
                                            options={chartOptions(true)} />
                                    }
                                    {
                                        datasets && signupMethod !== "All" &&<Line
                                            data={buildChartV2(labels, datasets[signupMethod])}
                                            options={chartOptions(true)} />
                                    }
                                </div>
                            </div>

                        </CardBody>

                        <CardHeader>
                            <Row>
                                <Col md="1" />
                                <Col md="10" className="m-4" style={{
                                    "border": "1px solid #ffffff50"
                                }} />
                            </Row>
                            <Row>
                                <Col className="text-left" sm="6">
                                    <h5>Sign up to Sync % { (signupMethod !== "All") && (" - " + signupMethod) }</h5>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="chart-area">
                                <div className="chart-area">
                                    {
                                        datasets && signupMethod === "All" &&
                                        <Line
                                            data={buildSignUpPercentChart(labels, datasets["All"])}
                                            options={chartOptions(true)} />
                                    }
                                    {
                                        datasets && signupMethod !== "All" &&
                                        <Line
                                            data={buildSignUpPercentChart(labels, datasets[signupMethod])}
                                            options={chartOptions(true)} />
                                    }
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>
    )
}